'use client';
import { useState } from 'react';

import { SectionGradient } from '@shared/common/components/BackgroundGradient/SectionGradient';

import { useAdjacentRounds } from '../../../api/useAdjacentRounds/useAdjacentRounds';
import {
  getPredictionRoundByState,
  PredictionRoundState,
} from '../../../model/AdjacentRound/roundState';
import { GetTokensButtons } from './GetTokensButtons/GetTokensButtons';
import { NextRoundCounter } from './NextRoundCounter/NextRoundCounter';
import { PredictionBanner } from './PredictionBanner/PredictionBanner';
import { PredictionPairButton } from './PredictionPairButton/PredictionPairButton';
import {
  PredictionsTab,
  PredictionsTabs,
  SelectedTabComponentMap,
} from './PredictionsTabs/PredictionsTabs';

export const PredictionMainSection = () => {
  const { data: rounds, isLoading } = useAdjacentRounds();
  const [selectedTab, setSelectedTab] = useState(PredictionsTab.PREDICTION);

  const lockedRound = getPredictionRoundByState({ rounds, state: PredictionRoundState.LOCKED });
  const SelectedTabContent = SelectedTabComponentMap[selectedTab];

  return (
    <div className="w-full max-w-full flex flex-col gap-6 items-center">
      <NextRoundCounter round={lockedRound} isLoading={isLoading} />
      <div className="flex gap-2 max-md-msq:flex-col max-sm-msq:w-full">
        <PredictionPairButton />
        <PredictionsTabs selectedTab={selectedTab} onChange={setSelectedTab} />
      </div>
      <SectionGradient>
        <SelectedTabContent />
      </SectionGradient>
      <GetTokensButtons />
      <PredictionBanner />
    </div>
  );
};
